import React, { PureComponent, ReactElement } from 'react';

import { Text } from '@philips-emr/tws-components';
import { msg } from '@philips-emr/tws-core/lib/services';

import './dialog-content.css';

interface DialogContentProps {
  children?: ReactElement | ReactElement[];
  description: string;
  uuid: string;
}

export default class DialogContent extends PureComponent<DialogContentProps> {

  private renderContent(): ReactElement | ReactElement[] {
    const { children, description } = this.props;

    if (children && Array.isArray(children) && children.length) {
      return children;
    }

    return (<Text>{msg(description)}</Text>);
  }

  public render(): ReactElement | ReactElement[] {
    return (
      <div className="c-dialog__content-wrapper__content">
        {this.renderContent()}
      </div>
    );
  }
}
